<template>
    <section>
        <div class="print:hidden">
            <form class="split-bill-form" v-on:submit.prevent>
                <span class="split-bill-label">{{$t('message.split_bill_verb')}}</span>
                <input class="form-control w-auto amount-input" v-model="disbursement" type="number">
                <span class="split-bill-label">{{activeOrganization.currency}} {{$t('message.split_bill_for')}}</span>
                <select v-model="type" class="form-control w-auto type-select">
                    <option value="cold">{{$t('message.cold_water')}}</option>
                    <option value="hot">{{$t('message.hot_water')}}</option>
                    <option value="total">{{$t('message.total_water')}}</option>
                    <option value="power">{{$t('message.electricity')}}</option>
                    <option value="gas">{{$t('message.gas')}}</option>
                    <option value="heat">{{$t('message.heat')}}</option>
                </select>
                <template v-if="type === 'hot'">
                    <span class="split-bill-label">{{$t('message.and_for_heating_water')}}</span>
                    <input type="text" v-model="heat" class="form-control w-auto amount-input">
                    <span class="split-bill-label">{{activeOrganization.currency}}</span>
                </template>
                <span class="split-bill-label">{{$t('message.split_bill_from')}}</span>
                <date-picker class="period-select" v-model="from" :config="configFrom"></date-picker>
                <span class="split-bill-label">{{$t('message.split_bill_to')}}</span>
                <date-picker class="period-select" v-model="to" :config="configTo"></date-picker>
                <span class="split-bill-label">{{$t('message.split_bill_in')}}</span>
                <select v-model="entity" class="form-control w-auto building-select">
                    <option
                        v-for="option in disbursementEntities"
                        :key="option.value.entityType + '-' + option.value.entityId"
                        :value="option.value"
                    >
                        {{ option.value.entityType === 'organization' ? $t('message.all_buildings') : option.text }}
                    </option>
                </select>
                <label class="include-validation">
                    <span>{{$t('message.include_validation_meter_data')}}</span>
                    <input v-model="includeValidation" type="checkbox">
                </label>
                <button @click="validate()" class="btn btn-danger btn-sm" type="button">
                    <i class="fa fa-spin fa-spinner mr-1" v-if="loading" aria-hidden="true"></i>
                    {{$t('message.split_bill')}}
                </button>
            </form>
        </div>
        <div v-if="mappedResult">
            <h1>{{$t('message.split_bill_heading')}} {{activeOrganization.name}} - {{ titleText(selectedType) }}</h1>
            <p> </p>
            <table class="summary-table">
                <tr>
                    <td>{{$t('message.billing_period')}}:</td>
                    <td><strong>{{fromStr}} - {{toStr}}</strong></td>
                </tr>
                <tr>
                    <td>{{$t('message.billing_total_consumption_apartments')}}:</td>
                    <td><strong>{{totalResult.waterTotal * koeficient | number}} {{ unit }}</strong></td>
                </tr>
                <tr v-if="totalResult.waterTotalControl > 0">
                    <td>{{$t('message.billing_total_consumption_control_meter')}}:</td>
                    <td><strong>{{totalResult.waterTotalControl * koeficient | number}} {{ unit }}</strong></td>
                </tr>
                <tr v-if="totalResult.waterTotalControl > 0">
                    <td>{{$t('message.billing_consumption_difference')}}:</td>
                    <td><strong>{{totalResult.difference * koeficient | number}} {{ unit }} ({{totalResult.differencePercentage}} %)</strong></td>
                </tr>
                <tr>
                    <td>{{$t('message.billing_price_per')}}:</td>
                  <td><strong>{{totalResult.costPerLiter | number}} {{activeOrganization.currency}} / {{unit}} = {{totalResult.costPerLiter * 1000}} {{activeOrganization.currency}} / <span v-if="selectedType == 'power'">kWh</span><span v-else>m<sup>3</sup></span></strong></td>
                </tr>
                <tr>
                    <td>{{$t('message.billing_leftover')}}:</td>
                    <td><strong>{{totalResult.costDiff}} {{activeOrganization.currency}}</strong></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
            </table>
            <a class="btn btn-default print:hidden" @click="validate('csv')" target="_blank">
                <i class="fa fa-download"></i> {{$t('message.download')}} CSV
            </a>
            <a class="btn btn-default print:hidden" @click="validate('xlsx')" target="_blank">
                <i class="fa fa-download"></i> {{$t('message.download')}} Excel
            </a>
        </div>
        <div class="flex flex-wrap -mx-2" v-if="mappedResult">
            <div class="w-full px-2" v-for="r in mappedResult">
                <h2>{{r.name}}</h2>
                <p v-if="r.tenants > 0">
                  {{$t('message.persons')}}: <strong>{{r.tenants}}</strong>
                </p>
                <p v-if="r.tenants > 0">
                  {{$t('message.total_consumption_per_person')}}: <strong>{{r.sum.perTenant * koeficient  | number}} {{$t(selectedType === 'power' ? 'kWh' : 'message.liters_after_number')}}</strong>
                </p>
                <p v-if="r.tenants > 0">
                  {{$t('message.daily_consumption_per_person')}}: <strong>{{r.sum.perTenantPerDay  * koeficient  | number}} {{$t(selectedType === 'power' ? 'kWh' : 'message.liters_after_number')}}</strong>
                </p>
                <table class="table border border-gray-200">
                    <thead>
                    <tr>
                        <th>{{$t('message.name')}}</th>
                        <th>{{$t('message.transmitter')}}</th>
                        <th>{{$t(selectedType === 'power' ? 'message.powermeter_label' : 'message.watermeter_label')}}</th>
                        <th>{{$t('message.seal_number')}}</th>
                        <th>{{$t('message.start_count')}}</th>
                        <th>{{$t('message.end_count')}}</th>
                        <th>{{$t('message.consumption')}}</th>
                        <th v-if="heat == 0">{{$t('message.split_amount')}}</th>
                        <th v-if="heat > 0">
                          {{$t('message.cost_of_consumption')}}
<!--                          {{$t('message.split_amount')}}-->
                        </th>
                        <th v-if="heat > 0">
                          {{$t('message.cost_of_heating_water')}}
<!--                          {{$t('message.split_amount')}}-->
                        </th>
                        <th v-if="heat > 0">
                          {{$t('message.total_cost')}}
<!--                          {{$t('message.split_amount')}}-->
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in r.items">
                        <td>{{item.transmitter_name}}</td>
                        <td>{{item.serial_number}}</td>
                        <td>{{item.watermeter_label}}</td>
                        <td>{{item.seal_number}}</td>
                        <td>{{item.start * koeficient | number}} {{unit}}</td>
                        <td>{{item.end * koeficient  | number}} {{unit}}</td>
                        <td>{{item.liters * koeficient  | number}} {{unit}}</td>
                        <td>{{item.cost}} {{activeOrganization.currency}}</td>
                        <td v-if="heat > 0">{{item.heat}} {{activeOrganization.currency}}</td>
                        <td v-if="heat > 0">{{item.total}} {{activeOrganization.currency}}</td>
                    </tr>
                    <tr class="bg-gray-100">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><strong>{{r.sum.liters * koeficient | number}} {{unit}}</strong></td>
                        <td><strong>{{r.sum.cost}} {{activeOrganization.currency}}</strong></td>
                        <td v-if="heat > 0"><strong>{{r.sum.heat  | number}} {{activeOrganization.currency}}</strong></td>
                        <td v-if="heat > 0"><strong>{{r.sum.total  | number}} {{activeOrganization.currency}}</strong></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import moment from 'moment'
    import mixins from '../modules/mixins'
    import { DatePicker as datePicker } from '../ui'

    export default {
        name: 'Disbursement',
        mixins: [mixins],
        components: {
            datePicker
        },
        data () {
            return {
                disbursement: 0,
                type: 'cold',
                from: moment().subtract(1, 'days').subtract(1, 'year').endOf('day'),
                to: moment().subtract(1, 'days').endOf('day'),
                fromStr: '',
                toStr: '',
                selectedType: '',
                heat: 0,
                entity: null,
                includeValidation: true,
                configFrom: {
                    format: 'DD.MM.YYYY',
                    useCurrent: false,
                    locale: 'cs',
                    maxDate: moment().subtract(1, 'days').endOf('day'),
                    useStrict: true,
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar-alt',
                        up: 'fa fa-chevron-up',
                        down: 'fa fa-chevron-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-dot-circle',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times'
                    }
                },
                configTo: {
                    format: 'DD.MM.YYYY',
                    useCurrent: false,
                    locale: 'cs',
                    maxDate: moment().subtract(1, 'days').endOf('day'),
                    useStrict: true,
                    icons: {
                        time: 'fa fa-clock',
                        date: 'fa fa-calendar-alt',
                        up: 'fa fa-chevron-up',
                        down: 'fa fa-chevron-down',
                        previous: 'fa fa-chevron-left',
                        next: 'fa fa-chevron-right',
                        today: 'fa fa-dot-circle',
                        clear: 'fa fa-trash-alt',
                        close: 'fa fa-times'
                    }
                }
            }
        },
        computed: {
            ...mapState({
                entities: state => state.entity,
                results: state => state.disbursement
            }),
            disbursementEntities () {
                return this.entities.all.disbursement
            },
            mappedResult () {
                return this.results.data.mapped
            },
            totalResult () {
                return this.results.data.total
            },
            loading () {
                return this.results.data.loading
            },
            unit () {
                return ['power', 'heat'].indexOf(this.selectedType) > -1 ? 'kWh' : 'l'
            },
            koeficient () {
                return ['power', 'heat'].indexOf(this.selectedType) > -1 ? 0.001 : 1
            }
        },
        watch: {
            disbursementEntities (value) {
                this.entity = value[0].value
            }
        },
        methods: {
            ...mapActions('entity', {
                getAllEntities: 'getAll'
            }),
            ...mapActions('disbursement', {
                calc: 'calc'
            }),
            validate (format) {
                if (Number(this.disbursement) < 0) {
                    this.notify('danger', 'Hodnota nesmí být menší než nula.')
                    return
                }
                if (!moment(this.from, 'DD.MM.YYYY').isValid()) {
                    this.notify('danger', 'message.invalid_date')
                    return
                }
                if (!moment(this.to, 'DD.MM.YYYY').isValid()) {
                    this.notify('danger', 'message.invalid_date')
                    return
                }
                if (this.entity == null) {
                    this.notify('danger', 'Nenení vybrána žadná volba')
                    return
                }
                const reqFrom = moment(this.from, 'DD.MM.YYYY').format('YYYY-MM-DD')
                const reqTo = moment(this.to, 'DD.MM.YYYY').format('YYYY-MM-DD')
                this.fromStr = moment(this.from, 'DD.MM.YYYY').format('DD.MM.YYYY')
                this.toStr = moment(this.to, 'DD.MM.YYYY').format('DD.MM.YYYY')
                this.selectedType = this.type
                const request = {
                    entityType: this.entity.entityType,
                    entityId: this.entity.entityId,
                    waterType: this.type,
                    disbursement: this.disbursement,
                    heat: this.heat,
                    from: reqFrom,
                    to: reqTo,
                    includeValidation: this.includeValidation ? 1 : 0,
                    format: format || 'json',
                    locale: this.getLanguage()
                }
                this.calc(request)
            },
            titleText (type) {
                switch (type) {
                case 'hot':
                    return this.$t('message.hot_water')
                case 'cold':
                    return this.$t('message.cold_water')
                case 'power':
                    return this.$t('message.electricity')
                case 'gas':
                    return this.$t('message.gas')
                case 'heat':
                    return this.$t('message.heat')
                default:
                    return this.$t('message.total_water')
                }
            }
        },
        created () {
            this.getAllEntities(this.activeOrganization.id)
        }
    }
</script>

<style scoped>
    .split-bill-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.45rem 0.55rem;
        row-gap: 0.65rem;
    }
    .split-bill-label {
        display: inline;
        margin: 0;
        color: #374151;
        font-size: 0.875rem;
        white-space: nowrap;
    }
    .amount-input {
        width: 5rem !important;
        min-width: 5rem;
        flex: 0 0 auto;
    }
    .type-select {
        width: auto !important;
        min-width: 10rem;
        flex: 0 0 auto;
    }
    .building-select {
        width: auto !important;
        min-width: 11rem;
        flex: 0 0 auto;
    }
    .include-validation {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        margin: 0;
        color: #374151;
        font-size: 0.875rem;
        font-weight: normal;
        white-space: nowrap;
    }
    .include-validation input {
        margin: 0;
    }
    .summary-table {
        margin-bottom: 20px;
    }
    .summary-table td {
        padding: 2px 5px;
    }
</style>
